import React from "react";
import Overview from "./Overview";

import { PositionProvider } from "../../context/PositionContext";

export const GeneratedDataEvents = () => {
  return (
    
      <PositionProvider>
        <Overview />
      </PositionProvider>
    
  );
};
